export function synchronizedMaxWithdrawalValue(
  maxSelected: boolean,
  currentValue: string,
  availableValue: string
) {
  return maxSelected && currentValue !== availableValue ? availableValue : undefined;
}
